import { PurchaseType } from '@thesavingsgroup/enums/PurchaseType';
import get from 'lodash/get';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehiclePurchaseType = (
  vehicle: DashboardVehicle,
): PurchaseType | undefined => {
  return get(vehicle, 'application.purchaseType');
};
